var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ontologies.length)?_c('div',{staticClass:"ontologies"},[_c('b-form-select',{attrs:{"options":_vm.ontologiesOption},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }